import PropTypes from 'prop-types';
import React from 'react';

import Badge from '../../Badge/Badge';

import RowItemBadges from './RowItemBadges';

const RowItemCustomBadge = React.memo(props => {
  const { isInteractive, useDarkTheme, useLightTheme, isCustomBadge, isFilled, isFullRowLink } =
    props;

  if (!isCustomBadge) {
    return null;
  }

  return (
    <RowItemBadges isInteractive={isInteractive} isFullRowLink={isFullRowLink}>
      <Badge
        badgeText={isCustomBadge}
        isDark={useDarkTheme}
        isLight={useLightTheme}
        isFilled={isFilled}
      />
    </RowItemBadges>
  );
});

RowItemCustomBadge.propTypes = {
  useDarkTheme: PropTypes.bool,
  useLightTheme: PropTypes.bool,
  isInteractive: PropTypes.bool,
  isCustomBadge: PropTypes.string,
  isFilled: PropTypes.bool,
  isFullRowLink: PropTypes.bool,
};

export default RowItemCustomBadge;
